import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import account from './store/account'
import gateway from './store/gateway'
import portal from './store/portal'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: { account, gateway, portal },
  plugins: process.env.NODE_ENV === 'development' ? [createLogger()] : []
})
